/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelBookingTravelersListResponse } from '../../models/travel-booking-travelers-list-response';

export interface BookingControllerTravelTravelers$Params {
  query?: string;
  limit: number;
  skip: number;
  travel_id: number;
}

export function bookingControllerTravelTravelers(http: HttpClient, rootUrl: string, params: BookingControllerTravelTravelers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingTravelersListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerTravelTravelers.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.path('travel_id', params.travel_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingTravelersListResponse;
      }>;
    })
  );
}

bookingControllerTravelTravelers.PATH = '/booking/travel/{travel_id}/travelers';
